import React from "react";
import Group from '../Groups/Group'
import {
    Link,
    useLocation
  } from "react-router-dom";

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({  
    root: {
    maxWidth: 240,
    display: "inline-block",
    width: "100%",
    textAlign: "left",
    margin: 20,
    verticalAlign: "top"
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  textDate: {
    display: "block",
    fontSize: 30,
    fontWeight: 600,
  },
  textTime: {
    width: "100%",
    textAlign: "right",
    display: "block",
  },
  expand: {
    '&:hover': {
        borderRadius: 5
      },
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

export default function Search() {
    const classes = useStyles();
    let query = useQuery();
    const s = query.get("s");

    const [labels, setLabels] = React.useState();

    if (labels === undefined) {
        fetch(process.env.REACT_APP_API_URL + "/search?s=" + s, {
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("BEARER_TOKEN")
            }
        })
        .then(response => response.json())
        .then((response) => {
            setLabels(response)
        })
    }

    if (labels === undefined)  return "caricamento" 


    return (<>
        {labels.length === 0 && <p>Nessun risultato trovato</p>}
        {labels && labels.map(label => {
            
            const d = new Date(label.created_at);

            return (<Link to={"/group/" + label.group_id + "/label/" + label.id} key={label.id}>
                <Card className={classes.root} >
                    <CardContent style={{paddingBottom: 0}}>
                        <div>
                            <span className={classes.textDate}> {d.getDate()} {monthNames[d.getMonth()]}</span>
                            <span className={classes.textTime}> {d.toString().substring(16, 21)} </span>
                        </div>
                        </CardContent>
                </Card>    
            </Link>
            )}
        )}
    </>)
}

const monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
];

